import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { applyChartTheme } from './components/charts/chartTheme';

/**
 * Register the shared Chart.js theme once, before anything renders.
 *
 * Doing it here rather than per-chart is what makes the rules enforceable: axis
 * titles, integer ticks on count axes, DOM legends instead of canvas ones, the
 * tokenised tooltip, and animation that switches off under prefers-reduced-motion.
 * Previously each chart carried its own options object — the tooltip config was
 * spelled out verbatim twice inside one file and a third, divergent time
 * elsewhere — so a chart could silently opt out of every one of those.
 */
applyChartTheme();

/**
 * Number fields: scrolling over a focused one must not raise or lower its value
 * (the browser does that by default). The arrows are hidden in index.css.
 */
document.addEventListener(
  'wheel',
  (event) => {
    const el = document.activeElement;
    if (el instanceof HTMLInputElement && el.type === 'number' && el === event.target) el.blur();
  },
  { passive: true }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
